class ValidateCadenciaError extends Error {
  constructor(msg) {
    super(msg);
    this.name = 'ValidateCadenciaError';
  }
}

export default ValidateCadenciaError;
